export default {
  "content": "<g clip-path=\"url(#clip0_30_1244)\" fill=\"#7B61FF\"><path d=\"M17 16H5v-2h12v2zM24 16h-4v-2h4v2z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M32 0a4 4 0 014 4v16a4 4 0 01-4 4H4a4 4 0 01-4-4V4a4 4 0 014-4h28zM2 20a2 2 0 002 2h28a2 2 0 002-2V9H2v11zM4 2a2 2 0 00-2 2v3h32V4a2 2 0 00-2-2H4z\"/></g><defs><clipPath id=\"clip0_30_1244\"><path fill=\"#fff\" d=\"M0 0h36v24H0z\"/></clipPath></defs>",
  "attrs": {
    "width": "36",
    "height": "24",
    "viewBox": "0 0 36 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};